import { AccuracySupplementalRowTypes } from "@app/exports/enumerations";
import { FeatureFlagContextProps, Features, withFeatureFlagContext } from "@app/feature-flags";
import { DropdownItem, MultiselectDropdown } from "@app/shared/checkbox-dropdown";
import { QESCheckbox } from "@app/shared/qes-standards";
import classNames from "classnames";
import { startCase, uniqueId } from "lodash";
import { Component } from "react";

type AccuracyRowTypeFilterProps = FeatureFlagContextProps & {
  onRowTypeChange: (recommendedAction: number) => void;
  onRowTypeChangeDropdown: (selections: DropdownItem<number>[]) => void;
  rowTypeIds: number[];
}

class WrappedAccuracyRowTypeFilter extends Component<AccuracyRowTypeFilterProps> {
  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">Row Type Filter</p>
        <p className="mb-1">Please select the row types to include:</p>
        {this.renderAccuracyRowTypes()}
      </>
    );
  }

  private renderAccuracyRowTypes() {
    const vbiUpdates = this.props.enabledFeatureFlags.has(Features.ENABLE_VIEW_BY_INSPECTION_UPDATES);
    const rowTypeItems: DropdownItem<number>[] = [];
    const selectedItems: DropdownItem<number>[] = [];
    let selectText = "";
    if (vbiUpdates) {
      Object.values(AccuracySupplementalRowTypes).forEach((v, i) => {
        if (v !== AccuracySupplementalRowTypes.Unknown && v !== AccuracySupplementalRowTypes.Undefined) {
          const item = {
            key: i,
            name: startCase(v),
          };
          rowTypeItems.push(item)
          if (this.props.rowTypeIds.indexOf(i) > -1) {
            selectedItems.push(item);
          }
        }
      });
      selectText = `${selectedItems.length} of ${rowTypeItems.length} options selected`;
    }

    return (
      <div className="form-group row" >
        {!vbiUpdates && <label className="col-12 col-form-label ptb0 text-left">Include</label>}
        <div className={classNames({
          "col-12": vbiUpdates,
          "col-xl-10 col-lg-9 mt0": !vbiUpdates,
        })}>
          {vbiUpdates ? (
            <MultiselectDropdown
              label="Row Type Filter"
              hideLabel={true}
              containerClassName="w-100"
              customSelectInputText={selectText}
              items={rowTypeItems}
              selectedItems={selectedItems}
              testId="accuracy-row-type-filter__dropdown"
              onSelectionChanged={(selections) => this.props.onRowTypeChangeDropdown(selections)}
            />
          ) : (
            Object.values(AccuracySupplementalRowTypes).map((v, i) => {
              const inputId = uniqueId(v);

              return (v !== AccuracySupplementalRowTypes.Unknown && v !== AccuracySupplementalRowTypes.Undefined) ? (
                <QESCheckbox
                  key={v}
                  containerClassName="form-check"
                  className="form-check-input mt-0"
                  id={inputId}
                  label={startCase(v)}
                  value={i.toString()}
                  checked={this.props.rowTypeIds.indexOf(i) > -1}
                  onChange={(e) => this.props.onRowTypeChange(parseInt(e.target.value, null))}
                  testId={`accuracy-row-type-checkbox--${i}`}
                />
              ) : null;
            })
          )}
        </div>
      </div>
    );
  }
}

const AccuracyRowTypeFilter = withFeatureFlagContext(WrappedAccuracyRowTypeFilter);
export default AccuracyRowTypeFilter;
